export default __webpack_public_path__ + "static/media/saft.143d28a9.svg";